import React, { useContext } from 'react';
import EDIconButton from '../../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDBox from '../../../../../../../../BaseComponents/EDBox/EDBox';
import EDIcon from '../../../../../../../../BaseComponents/Icon/EDIcon';
import EDTooltip from '../../../../../../../../BaseComponents/Tooltip/EDTooltip';
import EDTypography from '../../../../../../../../BaseComponents/Typography/EDTypography';
import { ObjektVyContext } from '../../../ObjektVy/ObjektVy';

const BusinessDataFormEditMenuAdjustSideWidths: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const objektVyContext = useContext(ObjektVyContext);

  const leftButtonDisabled =
    (objektVyContext[0].sidor?.[0]?.minSize ?? 1) ===
    objektVyContext[0].sidor?.[0]?.size;

  const rightButtonDisabled =
    (objektVyContext[0].sidor?.[1]?.minSize ?? 1) ===
    objektVyContext[0].sidor?.[1]?.size;

  return (
    <EDBox
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexGrow: '1',
        flexFlow: 'row nowrap',
      }}
    >
      <EDIconButton
        disabled={leftButtonDisabled}
        disabledReason={
          leftButtonDisabled
            ? 'Vänstersidan är inställd på minsta tillåtna storlek'
            : undefined
        }
        icon={
          <EDIcon
            color={leftButtonDisabled ? 'lowEmphasis' : 'primary'}
            iconType="arrow_back"
            testId="decreaseLeftIcon"
          />
        }
        iconSize="medium"
        margin="none"
        onClick={() => {
          objektVyContext[1]({
            type: 'setSidaVidSidaWidth',
            increaseSizeBy: 1,
            side: 'left',
          });
        }}
        tooltip="Justera åt vänster"
        testId="decreaseLeftButton"
      />
      <EDTooltip
        title="Justera förhållandet mellan vänster- och högersidan "
        enterDelay={100}
      >
        <EDTypography bold>
          {objektVyContext[0]?.adjustmentButtonsLabel}
        </EDTypography>
      </EDTooltip>
      <EDIconButton
        disabled={rightButtonDisabled}
        disabledReason={
          rightButtonDisabled
            ? 'Högersidan är inställd på minsta tillåtna storlek'
            : undefined
        }
        icon={
          <EDIcon
            color={rightButtonDisabled ? 'lowEmphasis' : 'primary'}
            iconType="arrow_forward"
            testId="decreaseRightIcon"
          />
        }
        iconSize="medium"
        margin="none"
        onClick={() => {
          objektVyContext[1]({
            type: 'setSidaVidSidaWidth',
            increaseSizeBy: 1,
            side: 'right',
          });
        }}
        tooltip="Justera åt höger"
        testId="decreaseRightButton"
      />
    </EDBox>
  );
};

export default BusinessDataFormEditMenuAdjustSideWidths;
